(function() {
    'use strict';
    angular.module('SMART2').service('NoolsEngine', [function () {
        this.execute = function (config) {
            var arrFields = [];
            var arrErrors = [];
            var headerOrGridConfig = config.uiConfig;
            var dataModel = config.dataModel;
            var ruleType = config.type;
            var rulesObj = config.rules;
            var scope = config.scope;

            if (ruleType == 'grid') {
                _.each(headerOrGridConfig[0].cloumnDefs, function (def) {
                    arrFields.push({
                        field: def.field,
                        type: def.type
                    });
                });
            }
            else if (ruleType == 'header') {
                _.each(headerOrGridConfig.sections, function (section) {
                    _.each(section.rows[0].properties, function (def) {
                        arrFields.push({
                            field: def.data,
                            type: def.type,
                            attributes: def.attributes
                        });
                    });
                });
            }

            var flow = nools.compile(rulesObj, { name: 'totalErrors' });
            var Message = flow.getDefined("message");

            if (ruleType == 'grid') {
                dataModel = dataModel.orderData.items[0];
            }
            else {
                dataModel = dataModel;
            }

            _.each(arrFields, function (man) {
                var messageModel = [new Message({
                    ui: man,
                    dataModel: dataModel,
                    scope: scope
                })];

                var session = flow.getSession.apply(flow, messageModel).focus('empty');

                session.on("error", function (data) {
                    arrErrors.push(data.errors[0]);
                }).on('fire', function (name) { });

                session.match(function (data) {
                    session.dispose();
                    nools.deleteFlow('totalErrors');
                });
            });

            if (arrErrors.length == 0) {
                angular.isFunction(config.success) && config.success();
            }
            else {
                angular.isFunction(config.error) && config.error({
                    data: arrErrors
                });
            }

            return dataModel;
        };
    }]);
})();